import React from "react";
import { colors, radius, shadow } from "./tokens";

export function Card({ children, style, noPadding }: { children: React.ReactNode; style?: React.CSSProperties; noPadding?: boolean }) {
  return (
    <div style={{
      backgroundColor: colors.card, border: `1px solid ${colors.border}`, borderRadius: radius.lg,
      boxShadow: shadow, padding: noPadding ? 0 : 20, ...style,
    }}>
      {children}
    </div>
  );
}

export function PageHeader({ title, subtitle, action }: { title: string; subtitle?: string; action?: React.ReactNode }) {
  return (
    <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 24, gap: 16, flexWrap: "wrap" }}>
      <div>
        <h1 style={{ fontSize: 26, fontWeight: 800, letterSpacing: -0.3, color: colors.text, margin: 0 }}>{title}</h1>
        {subtitle && <p style={{ color: colors.textMuted, marginTop: 4, fontSize: 13.5 }}>{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
